import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import "./TextArea.scss"
import Tooltip from "@mui/material/Tooltip";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import { useDispatch } from "react-redux";
import { RootState } from "../../store/reducers";
import { useSelector } from "react-redux";
import { FormControl, InputLabel, MenuItem, Select, InputAdornment, Input, OutlinedInput, TextField } from "@mui/material";

export default function TextArea(props: any) {
  const { name, label, value, placeholder, handlechange,type,adornmentType,adornmentText,options,required } = props;
  const dispatch = useDispatch();
  const {
    freezScreenState,
    alertMessageState,
    setStoreId
  } = bindActionCreators(actionCreators, dispatch);
  const state = useSelector((state: RootState) => state.appReducer);
  const { userInfo, freezScreen } = state;
  const appState = useSelector((state: RootState) => state.apiReducer);


  return (

    <div id="TextArea" className="">
      <p className="mb-0 label mb-1 familysora600">{label}</p>
      <FormControl size="small">
        <TextField
        className="w-100"
          hiddenLabel
          id="filled-hidden-label-small"
          placeholder={placeholder}
          required={required}
          value={value}
          multiline={true}
          rows ={options.rows}
          name= {name}
          variant="filled"
          size="small"
          onChange={handlechange}
          type={type ? type : "text"}
          InputProps={
            adornmentType === "endAdornment"
              ? {
                  endAdornment: <InputAdornment position="end">{adornmentText}</InputAdornment>,
                }
              : {}
          }
        />
      </FormControl>
    </div>

  );
}
